import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STAFF_KEY = 'fa-staff-token';
export const MESSAGE_KEY = 'fa-message';

export const isImpersonating = () => !!localStorage.getItem(STAFF_KEY);
let restoring = false;
export const isRestoring = () => restoring;

export const startImpersonation = (token) => {
  localStorage.setItem(STAFF_KEY, localStorage.getItem('token'));
  localStorage.setItem('token', token);
  sessionStorage.removeItem('last-path');
  window.location.assign('/');
};

// İSG uzmanının kendi oturumuna geri döner; firma erişimi yoksa false
export const restoreStaff = (message) => {
  const staff = localStorage.getItem(STAFF_KEY);
  if (!staff) return false;
  restoring = true;
  localStorage.setItem('token', staff);
  localStorage.removeItem(STAFF_KEY);
  sessionStorage.removeItem('last-path');
  if (message) sessionStorage.setItem(MESSAGE_KEY, message);
  window.location.assign('/firma-erisimi');
  return true;
};

export const exitImpersonation = async () => {
  try { await axios.post(`${API}/firm-access/exit`); } catch { /* süre zaten dolmuş olabilir */ }
  restoreStaff('Firma erişiminden çıkış yapıldı');
};

export const useCountdown = (expiresAt) => {
  const calc = () => (expiresAt ? Math.max(0, Math.floor((new Date(expiresAt) - Date.now()) / 1000)) : 0);
  const [left, setLeft] = useState(calc);
  useEffect(() => {
    setLeft(calc());
    if (!expiresAt) return undefined;
    const t = setInterval(() => setLeft(calc()), 1000);
    return () => clearInterval(t);
  }, [expiresAt]); // eslint-disable-line react-hooks/exhaustive-deps
  return left;
};

export const fmtClock = (s) => `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;

export const STATUS_LABELS = {
  pending: { label: 'Onay Bekliyor', color: 'bg-amber-100 text-amber-800' },
  active: { label: 'Aktif', color: 'bg-red-100 text-red-700' },
  rejected: { label: 'Reddedildi', color: 'bg-slate-200 text-slate-700' },
  request_expired: { label: 'Yanıtlanmadı (Düştü)', color: 'bg-slate-100 text-slate-600' },
  cancelled: { label: 'İptal Edildi', color: 'bg-slate-100 text-slate-600' },
  ended: { label: 'Sona Erdi', color: 'bg-emerald-100 text-emerald-700' },
};

export const END_REASONS = {
  timeout: 'Süre doldu',
  staff_exit: 'İSG çıkış yaptı',
  firm_revoked: 'Firma iptal etti',
  permission_revoked: 'Yetki kaldırıldı',
};
